import { PillCell, TextWrapCell } from "../../Utils/DataTable/Cells"

const CELLS = {
  framework: TextWrapCell,
  policy_status: PillCell
}

export default CELLS